import { useState, useEffect, useRef } from "react";

export function useRepoFilterState() {
  const [searchTerm, setSearchTerm] = useState("");
  const [typeFilters, setTypeFilters] = useState(["all"]);
  const [dayFilter, setDayFilter] = useState("All");
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [tempSortOrder, setTempSortOrder] = useState("Descending");
  const [tempDayFilter, setTempDayFilter] = useState("All");
  const [tempFolderSort, setTempFolderSort] = useState("Top");
  const [appliedSortOrder, setAppliedSortOrder] = useState("Descending");
  const [appliedFolderSort, setAppliedFolderSort] = useState("Top");
  const filterDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        filterDropdownRef.current &&
        !filterDropdownRef.current.contains(event.target)
      ) {
        setShowFilterDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside, true);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside, true);
  }, []);

  const handleApplyFilter = (setCurrentPage) => {
    setDayFilter(tempDayFilter);
    setAppliedSortOrder(tempSortOrder);
    setAppliedFolderSort(tempFolderSort);
    setShowFilterDropdown(false);
    setCurrentPage(1);
  };

  const handleResetFilter = (setCurrentPage) => {
    setTempSortOrder("Descending");
    setTempDayFilter("All");
    setTempFolderSort("Top");
    setDayFilter("All");
    setAppliedSortOrder("Descending");
    setAppliedFolderSort("Top");
    setShowFilterDropdown(false);
    setCurrentPage(1);
  };

  const handleTypeFilterChange = (filter, setCurrentPage) => {
    // Single-select: picking an option replaces the previous selection
    setTypeFilters(filter === "all" ? ["all"] : [filter]);
    setCurrentPage(1);
  };

  return {
    searchTerm,
    setSearchTerm,
    typeFilters,
    dayFilter,
    setDayFilter,
    showFilterDropdown,
    setShowFilterDropdown,
    tempSortOrder,
    setTempSortOrder,
    tempDayFilter,
    setTempDayFilter,
    tempFolderSort,
    setTempFolderSort,
    appliedSortOrder,
    setAppliedSortOrder,
    appliedFolderSort,
    setAppliedFolderSort,
    filterDropdownRef,
    handleApplyFilter,
    handleResetFilter,
    handleTypeFilterChange,
  };
}
